import React, { useState, useEffect } from "react";
import Table from "../../../../../components/table";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Create, Get } from "../../../../../actions";
import { Get_AllCircularResolutionsWithPagination_URL, Get_CancelCircularResolution_URL } from "../../../../../constants/apiUrls";
import { DatePicker } from "@material-ui/pickers";
import { Box, Button, Card, CardContent, Grid, IconButton, Typography } from "@material-ui/core";
import { AssignmentReturn, Cancel, RemoveCircle, Repeat, RepeatRounded, Toc } from "@material-ui/icons";
import { getTranslation } from "../../../../../heplers/translationHelper";
import DialogComponent from "../../../../../components/Dialog";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";

const columns = [
	{
		id: "subject",
		numeric: false,
		disablePadding: true,
		label: getTranslation("Subject", "Sujette", "Fach"),
	},
	{
		id: "language",
		numeric: false,
		disablePadding: true,
		label: getTranslation("Language", "Langue", "Sprache"),
	},
	{
		id: "personInchargeName",
		numeric: false,
		disablePadding: true,
		label: getTranslation(
			"Person Incharge",
			"Personne en charge",
			"Verantwortlicher"
		),
	},

	{
		id: "deadline",
		numeric: false,
		disablePadding: true,
		format: "date",
		label: getTranslation("Date", "Date", "Datum"),
	},
	// {
	// 	id: "resultText",
	// 	numeric: false,
	// 	disablePadding: true,
	// 	label: getTranslation("Result", "Résultat", "Ergebnis"),
	// },
	{
		id: "yesCount",
		numeric: false,
		disablePadding: true,
		label: getTranslation("Accepted"),
		align:"center",
		component:({row})=><Typography style={{textAlign:"center"}} >{row.yesCount}</Typography>
	},
	{
		id: "noCount",
		numeric: false,
		disablePadding: true,
		label: getTranslation("Declined"),
		align:"center",
		component:({row})=><Typography style={{textAlign:"center"}} color={row.noCount>0? "error":"lightgreen"}>{row.noCount}/{row.decisionMakersCount}</Typography>
	},
	{
		id: "statusText",
		numeric: false,
		disablePadding: true,
		label: getTranslation("Status", "Statut", "Status"),
	},
	{
		id: "actions",
		numeric: true,
		disablePadding: false,
		align: "right",
		label: getTranslation("Logs", "Journaux", "Protokolle"),
	},
];

// const Funds = [
//   {
//     id: "001",
//     title: "Company",
//     investerRelation: "Asghar",
//     manager: "Khan",
//   },
// ];
// this is template for list given
export const CircularResolutionList = ({managementCompanyId}) => {


	var d = new Date();
	d.setMonth(d.getMonth() - 3);
	const [fromDate, setFromDate] = useState(d);
	var to = new Date();
	to.setMonth(to.getMonth() + 3);
	const [toDate, setToDate] = useState(to);
	const [pageSize, setPageSize] = useState(10);
	const [searchString, setSearchString] = useState("");


	const history = useNavigate();
	const { enqueueSnackbar } = useSnackbar();
	const [open, setOpen] = useState(null);
	const [canceling, setCanceling] = useState(false);
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(0);
	let spvCRList = localStorage.getItem("spvCRList");
	if (spvCRList == null) {
		localStorage.setItem("spvCRList", 10);
		spvCRList = 10;
	}
	const [rowsPerPage, setRowsPerPage] = useState(spvCRList);
	// const [rows, setRows] = useState([]);
	// const [loadingFunds, setloadingFunds] = useState(false);

	//   useEffect(() => {
	//     dispatch({ type: "Clear_All_BreadCrumb" });
	//     dispatch({
	//       type: "Add_BreadCrumb",
	//       payload: { title: "Funds", url: "/funds" },
	//     });
	//   }, []);

	// const { activities } = useSelector((state) => state.activities);
	const [circularMeetings, setCircularMeetings] = useState([]);

	const loadCircularMeetings = () => {
		setLoading(true)
		Get(
		  {
			managementCompanyId: managementCompanyId,
			searchString: searchString,
			from: fromDate,
			to: toDate,
			pageNumber: page,
			pageSize: pageSize,
		  },
		  Get_AllCircularResolutionsWithPagination_URL,
		  null,
		  (resp) => {
			setCircularMeetings(resp.data);
		setLoading(false)

		  },
		  (error) => {
		setLoading(false)

		  }
		);
	  };
	
	  useEffect(() => {
		loadCircularMeetings();
	  }, [managementCompanyId,page,pageSize,searchString]);
	

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		localStorage.setItem("spvCRList", event.target.value);
		setRowsPerPage(parseInt(event.target.value));
		setPage(0);
	};


	const handleDetailCompany = (row) => {
		// // navigting to this route"/meetings/:managementCompanyId/circularResolution/:circularResolutionId"
		history(row.id);
	};
	const handleOpenAuditLog = (row) => {
		history(row.id + "/auditlogs");
	};

	const handleCancel = (row, repeat) => {
    setCanceling(true);
    Get(
      {
        id: row.id,
        repeat: repeat,
      },
      Get_CancelCircularResolution_URL,
      null,
      (resp) => {
        setOpen(null);
        setCanceling(false);
		loadCircularMeetings()
      },
      (error) => {
        setCanceling(false);
      }
    );
  };

	return (
    <div>
      <Table
        dense
        loading={loading}
        colums={columns}
        sortBy="meetingDate"
        rows={circularMeetings?.data}
        count={circularMeetings?.totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={(event, newPage) => handleChangePage(event, newPage)}
        handleChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
        viewEdit
        onEdit={(row) => handleDetailCompany(row)}
        actions={[
          {
            component: (row) =>
              row.isCancelled ?<Box style={{border:"1px solid #FAA0A0",padding:"5px"}}><Typography style={{color:"#FAA0A0"}}>Cancelled</Typography></Box>:
              row.noCount > 0 && (
                <IconButton onClick={() => setOpen(row)}>
                  <RemoveCircle style={{ color: "red" }} />
                </IconButton>
              ),
          },
          {
            component: (row) => (
              <IconButton onClick={() => handleOpenAuditLog(row)}>
                <Toc />
              </IconButton>
            ),
          },
        ]}
        // viewDelete
        // onDelete={(row) => handleOpenDeleteDialog(row)}
        viewSearch
        onSearch={(searchString) => {
			setPage(0)
			setSearchString(searchString)
		}}
      />
      <DialogComponent
        open={open!=null}
        title={getTranslation("Confirmation")}
        fullWidth
        onClose={()=>setOpen(null)}
      >
		  <Typography>Are you sure? This action is not revertable.</Typography>
		  <br/>
		  <br/>
			<Box display="flex" justifyContent="space-between">
				<Button disabled={canceling} onClick={()=>setOpen(null)}>Close</Button>
				<ButtonWithLoading loading={canceling} title="Confirm & Cancel"  variant="contained" style={{ background: canceling? "#F88379": "#FF3131", color: "white" }} onClick={()=>handleCancel(open,false)}/>
				<ButtonWithLoading loading={canceling} title="Confirm & Repeat"  variant="contained" style={{ background:  canceling? "#F88379":"#FF3131", color: "white" }} onClick={()=>handleCancel(open,true)}/>
			</Box>
	  </DialogComponent>
    </div>
  );
};
